import React from "react";
import { CalendarDays, CheckCircle, FileText, Clock } from "lucide-react";
import "../../style/Timeline.css";

function Timeline() {
  return (
    <div id="timeline" className="timeline-section">
      <h2>Important Dates</h2>

      <div className="timeline">

        <div className="timeline-item">
          <div className="timeline-dot"></div>
          <div className="timeline-content">
            <h3>
              <CalendarDays size={20} style={{ marginRight: "8px" }} />
              Last date of Abstract Submission
            </h3>
            <p>10th March 2026</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot"></div>
          <div className="timeline-content">
            <h3>
              <CheckCircle size={20} style={{ marginRight: "8px" }} />
              Confirmation of Abstract Acceptance
            </h3>
            <p>15th March 2026</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot"></div>
          <div className="timeline-content">
            <h3>
              <CalendarDays size={20} style={{ marginRight: "8px" }} />
              Last date of Payment of Registration Fee
            </h3>
            <p>20th March 2026</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot"></div>
          <div className="timeline-content">
            <h3>
              <FileText size={20} style={{ marginRight: "8px" }} />
              Last date of Full Paper Submission
            </h3>
            <p>5th April 2026</p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot"></div>
          <div className="timeline-content">
            <h3>
              <Clock size={20} style={{ marginRight: "8px" }} />
              Final Confirmation of Acceptance
            </h3>
            <p>15th April 2026</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Timeline;
